<template>
  <div class="inner-container" @click="click">
    <van-image
      v-if="coverData"
      :src="coverData.private_cdns[0].cdn_url"
      radius="4px"
    />
    <van-image
      v-else
      :src="episodeData.cover.private_cdns[0].cdn_url"
      radius="4px"
    />
    <div class="desc van-multi-ellipsis--l2">{{episodeData.description}}</div>
  </div>
</template>

<script>
  import Vue from 'vue'
  import { Image as VanImage } from 'vant'
  Vue.use(VanImage)

  export default {
    components: {
      VanImage
    },
    props: {
      episode: {
        type: Object,
        default: function () {
          return {
            title: '',
            description: '',
            price: {
              amount: 0,
              origin: 0
            },
            cover: {
              private_cdns: [{ "cdn_url": "" }]
            }
          }
        }
      },
      episodeId: {
        type: Number,
        default: 0
      }
    },
    computed: {},
    watch: {
      episodeId: {
        handler: function (episodeId) {
          if (episodeId && episodeId != 0) {
            this.$api.episode.detail(episodeId).then(res => {
              window.console.log("已经获取到 EPISODE DETAIL")
              window.console.log(res.data)
              this.episodeData = res.data
              this.$api.image.detail(res.data.cover).then(res => {
                window.console.log("获取到封面")
                window.console.log(res)
                this.coverData = res.data
              })
            })
          }   
        },
        immediate: true
      },
      episode: {
        handler: function (episode) {
          if (episode.hasOwnProperty('title')) {
            this.episodeData = episode
          }
        },
        immediate: true
      }
    },
    data () {
      return {
        episodeData: {
          cover: {
            private_cdns: [{ "cdn_url": "" }]
          }
        },
        coverData: {
          private_cdns: [{ "cdn_url": "" }]
        }
      }
    },
    methods: {
      click () {
        this.$router.replace({
          name: 'EpisodeDetail',
          params: {
            episodeId: this.episodeData.id
          }
        })
      }
    },
    mounted () {}
  }
</script>

<style lang="css" scoped>
  .inner-container {
    /* width: 30vw; */
    display: flex;
    flex-direction: column;
  }
  .desc {
    margin: 10px 0 0px 0;
    color: #666;
    line-height: 125%;
    font-size: 0.85em;
  }
</style>
